import {
  GET_STATISTICS,
  GET_STATISTICS_SUCCESS,
  GET_STATISTICS_PREV_YEAR_SUCCESS,
} from '../constants/ActionsTypes'

const initialState = {
  results: [],
  previousYearResults: [],
}

function rootReducer(state = initialState, action) {
  switch (action.type) {
    case GET_STATISTICS:
      return { ...state }
    case GET_STATISTICS_SUCCESS:
      return {
        ...state,
        results: action.data,
      }
    case GET_STATISTICS_PREV_YEAR_SUCCESS:
      return {
        ...state,
        previousYearResults: action.data,
      }
    default:
      return state
  }
}

export default rootReducer
